import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { DailyQuarterHourlyHistogram } from "./DailyQuarterHourlyHistogram";
import DailyQuarterHourlyHistogramQueryNode, {
  type DailyQuarterHourlyHistogramQuery$variables,
} from "./__generated__/DailyQuarterHourlyHistogramQuery.graphql";
import {
  info,
  type Option,
  optionToVariables,
} from "./DailyQuarterHourlyHistogramOptions";

function getOption(url: URL): Option {
  const option = url.searchParams.get("filter");

  // eslint-disable-next-line no-prototype-builtins
  if (option && info.hasOwnProperty(option)) {
    return option as Option;
  }

  return "ALL_TIME";
}

const entryPoint: SimpleEntryPoint<typeof DailyQuarterHourlyHistogram> = {
  root: JSResource("DailyQuarterHourlyHistogram", () =>
    import("./DailyQuarterHourlyHistogram").then(
      (module) => module.DailyQuarterHourlyHistogram,
    ),
  ),
  getPreloadProps({ request }) {
    const url = new URL(request.url);
    const variables: DailyQuarterHourlyHistogramQuery$variables =
      optionToVariables(getOption(url), new Date());

    return {
      queries: {
        query: {
          parameters: DailyQuarterHourlyHistogramQueryNode,
          variables,
        },
      },
    };
  },
};

export default entryPoint;
